/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import ContactMail from "@mui/icons-material/ContactMail";
import Phone from "@mui/icons-material/Phone";
import Favorite from "@mui/icons-material/Favorite";
// core components
//Use the HeaderTribalism2 element when adding in the top banner!!
//import Header from "components/Header/HeaderTribalism2.js";
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
//import Parallax from "components/Parallax/Parallax.js";
import Parallax from "components/Parallax/Parallax_noscale.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

// sections for this page
import AboutUs from "pages-sections/services/google-ads-services/AboutUs.js";
import Examples from "pages-sections/services/google-ads-services/Examples.js";
import AdsPackage from "pages-sections/services/google-ads-services/AdsPackage.js";
import Guarantee from "pages-sections/services/google-ads-services/Guarantee.js";
import WhyUs from "pages-sections/services/google-ads-services/WhyUs.js";
import OurApproach from "pages-sections/services/google-ads-services/OurApproach.js";

import SectionText from "pages-sections/services/google-ads-services/SectionText.js";

import SectionBlogInfo from "pages-sections/blog-post/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/SectionSimilarStories.js";
import Section4Clients from "pages-sections/home-page/Section4ClientsLandingPage.js";
import Section8Contacts from "pages-sections/home-page/Section8Contacts.js";

import classNames from "classnames";
import Box from "@mui/material/Box";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Image from "next/image";




import Banner from "components/Banner/Banner.js";
import SimilarPages from "pages-sections/glossary/wd-SimilarPages.js";

import data from "data/wddlinksData.js"; // Adjust the path accordingly
import styles from "../../../pages-sections/services/ServicesSections.module.scss";

const main_section = "web_development";
const sub_section = "programming_languages_and_markup_languages";
const this_page = "html";

export async function getStaticPaths() {
  // Assume data is imported or defined here
  // const data = require("data/linksData3.js");

  // Function to extract links from an object
  const extractLinks = (obj) => {
    return obj && obj.links
      ? obj.links.map((link) => ({ params: { fname: link.fname } }))
      : [];
  };

  // Extract links from different objects
  const programming_languages_and_markup_languagesLinks = extractLinks(
    data.web_development.programming_languages_and_markup_languages
  );
  const frameworks_and_librariesLinks = extractLinks(
    data.web_development.frameworks_and_libraries
  );

  const database_technologiesLinks = extractLinks(
    data.web_development.database_technologies
  );

  const web_development_conceptsLinks = extractLinks(
    data.web_development.web_development_concepts
  );

  const design_and_prototypingLinks = extractLinks(
    data.web_development.design_and_prototyping
  );

  const development_processes_and_methodologiesLinks = extractLinks(
    data.web_development.development_processes_and_methodologies
  );

  const tools_and_platformsLinks = extractLinks(
    data.web_development.tools_and_platforms
  );

  const security_and_networkingLinks = extractLinks(
    data.web_development.security_and_networking
  );

  /*const database_technologiesLinks = extractLinks(
    data.web_development.database_technologies
  );*/

  // console.log(programming_languages_and_markup_languagesLinks);

  // Combine all links
  const allLinks = [
    ...programming_languages_and_markup_languagesLinks,
    ...frameworks_and_librariesLinks,
    ...database_technologiesLinks,
    ...web_development_conceptsLinks,
    ...design_and_prototypingLinks,
    ...development_processes_and_methodologiesLinks,
    ...tools_and_platformsLinks,
    ...security_and_networkingLinks,
  ];
  // Add more arrays here if needed

  return { paths: allLinks, fallback: false };
}

export async function getStaticProps({ params }) {
  // const data = require("data/linksData3.js"); // Adjust path to your actual data file

  let pageData = null;
  let parentObjectName = null;

  // Loop through each key in web_analytics
  for (const key in data.web_development) {
    if (data.web_development.hasOwnProperty(key)) {
      const obj = data.web_development[key];
      //console.log("Checking in object:", key); // Debugging output
      const foundLink = obj.links.find((link) => link.fname === params.fname);
      if (foundLink) {
        //console.log("Found link in:", key); // Debugging output
        pageData = foundLink;
        parentObjectName = key;
        break; // Found the link, break out of the loop
      }
    }
  }

  // If no pageData is found, return notFound
  if (!pageData) {
    return { notFound: true };
  }

  // Return both pageData and the name of its parent object
  return { props: { pageData, parentObjectName } };
}

export default function BlogPostPage({ pageData, parentObjectName }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;

  // Extract the description from pageData
  const pageDescription = pageData.description;
  const pageName = pageData.name;
  const pageTitle = pageData.name + "- Definition - Tribalism";
  const pageSection = parentObjectName;

  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title={pageTitle}
        //image="/img/sections/services/all-services/4-sm.webp"
        image="/img/sections/services/all-services/melbourne-sm.webp"
        url="https://www.tribalism.com.au/services/web-analytics"
        type="article"
        //description="We are an Analytics, Web Development and Digital Marketing Agency based in Melbourne. We can get started on big-impact projects for your business immediately! Reach out any time."
        description={
          pageDescription ||
          "We are an Analytics, Web Development and Digital Marketing Agency based in Melbourne. We can get started on big-impact projects for your business immediately! Reach out any time."
        }
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />

      <Parallax
        image="/img/sections/services/all-services/7-sm.webp"
        filter="dark"
      ></Parallax>

      <div className={classes.main} style={{ marginTop: "30px" }}>
        <div
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/img/bgs/bgpink2.jpg')",
            //boxShadow:
            //  "0 4px 20px 0px rgb(0 0 0 / 14%), 0 7px 12px -5px rgb(0 172 193 / 46%)",
          }}
        >
          <div className={classes.container}>
            <div className={classes.sectionGlossary} style={{ padding: "0px" }}>
              <GridContainer
                alignItems="center"
                spacing={8}
                style={{ padding: "0px" }}
              >
                <GridItem xs={12} sm={10} md={10} lg={10}>
                  <h2 className={classes.title}>{pageName}</h2>
                  <h3 className={classes.title}>Definition</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: pageData.content.join(" "),
                    }}
                  />
                  <br /> <br />
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
        <SimilarPages
          main_section={main_section}
          sub_section={pageSection}
          this_page={pageName}
        />

        <Section8Contacts id="testimonials" />
      </div>
      <Footer
        content={
          <div>
            <div className={classes.left}></div>
          </div>
        }
      />
    </div>
  );
}
